var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vh-margin-top"},[(_vm.chips.length)?_c('p',{staticClass:"vh-margin-remove"},[_vm._v("\n        You have search / filter:\n    ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.chips),function(item,index){return _c('vh-badge',{key:index,attrs:{"item":item},on:{"reset":function($event){return _vm.reset(item.query)}}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-000ce22f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/query-badge/vh-query-badge.vue
// module id = null
// module chunks = 